// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"22d56ecd","667":"fa359948","977":"e6c53912"}[chunkId] + ".chunk.js";
};